module.exports = __webpack_public_path__ + "static/media/img1.6cf10c88.png";